export default __webpack_public_path__ + "static/logo_union_europea_es-a2bd9f007d7dbe715440587c682daf2d.webp";